/* eslint-disable import/prefer-default-export */

/**
 * Convert a string to boolean value
 * @param {String} str string to be converted
 */
export function stringToBoolean(str) {
  if (str === '1' || str === 'true' || str === 'yes' || str === 'Yes') {
    return true;
  }
  if (str === '0' || str === 'false' || str === 'no' || str === 'No') {
    return false;
  }
  return str;
}

export function getIntOrDefault(value, defaultValue) {
  const int = parseInt(value);
  return int > 0 ? int : defaultValue;
}